"use server";

import { signIn } from "@/auth";
import { AuthError } from "next-auth";
import { redirect } from "next/navigation";

export async function signInWithPin(pin: string, redirectTo: string) {
  try {
    await signIn("dev-pin", { pin, redirectTo });
  } catch (err) {
    if (err instanceof AuthError) {
      return { error: "Incorrect PIN" };
    }
    throw err;
  }
}
